import { React } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import Modal from 'sushiweb/Modal';
import SelectPlan from './SelectPlan';
import ReviewPlan from './ReviewPlan/ReviewPlan';
import FormTemplate from '../../../../WalletPrograms/CreateProgramModal/ProgramForms/common/Components/FormTemplate';

const AddPlanToGroupBtns = ({ group, isVisible, closeModal }) => {
  const renderBody = () => {
    return (
      <FormTemplate>
        <SelectPlan step={1} groupDetails={group} />
        <ReviewPlan step={2} groupDetails={group} closeModal={closeModal} />
      </FormTemplate>
    );
  };

  return (
    <>
      <Modal
        visible={isVisible}
        onClose={closeModal}
        type='flex'
        title='Add meal plan'
        isCentered
      >
        {isVisible && renderBody()}
      </Modal>
    </>
  );
};

AddPlanToGroupBtns.propTypes = {
  group: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
};
AddPlanToGroupBtns.defaultProps = {
  group: {},
  isVisible: false,
  closeModal: _noop,
};

export default AddPlanToGroupBtns;
